import { FaArrowUp, FaClock, FaGraduationCap, FaSeedling, FaUsers } from 'react-icons/fa';

const careerIntro = {
    sub: "Kariera i Wolontariat",
    heading: "Zdobądź doświadczenie, które ma znaczenie",
    description: "Chcesz zdobyć doświadczenie, które naprawdę ma znaczenie? Szukasz miejsca, w którym Twoje pomysły zostaną zauważone, a Twoja praca przełoży się na realne działanie?\n\n Zapraszamy na praktyki i staże w naszej fundacji. U nas nie parzysz kawy — tworzysz projekty, rozwijasz nowe umiejętności i współpracujesz z ludźmi, którzy z pasją zmieniają rzeczywistość. \nPracujemy blisko społeczności, kultury i edukacji, tworząc inicjatywy, które wpływają na otoczenie.",
    points: [
        'udział w projektach społecznych, edukacyjnych i kulturalnych,',
        'wsparcie doświadczonych opiekunów,',
        'pracę w kreatywnym, przyjaznym zespole,',
        'elastyczne formy odbywania praktyk (stacjonarne, hybrydowe, zdalne),',
        'rozwijanie umiejętności organizacyjnych, komunikacyjnych i projektowych,',
        'zaświadczenie o odbyciu praktyk lub stażu.'
    ],
}

const positions = [
    {
    },
];

const benefits = [
    {
        id: 1,
        title: 'Dla kogo?',
        description: '- uczniów i studentów chcących zrealizować obowiązkowe praktyki, \n- absolwentów poszukujących pierwszego doświadczenia,\n- osób chcących rozwijać kompetencje i zaangażować się w działania społeczne, \n- osób kreatywnych, otwartych, gotowych na nowe wyzwania. ',
        icon: <FaSeedling />
    },
    {
        id: 5,
        title: 'Proces rekrutacji',
        description: '1. Wyślij zgłoszenie (CV lub krótki opis o sobie). \n2. Skontaktujemy się z Tobą, aby odbyć krótką rozmowę.  \n3. Ustalimy zakres praktyk oraz terminy.  \n4. Zaczynasz współpracę — witamy na pokładzie!',
        icon: <FaUsers />
    },
    {
        id: 3,
        title: 'Mile widziane:',
        description: '- komunikatywność, \n- sumienność, \n- inicjatywa, \n- umiejętności kreatywne(grafika, foto/ video, social media - ale nie są obowiązkowe).',
        icon: <FaArrowUp />
    },
    {
        id: 4,
        title: 'Czas trwania',
        description: '- minimalny czas praktyk: 2–4 tygodnie,\n- możliwość dłuższej współpracy, \n- elastyczne godziny dopasowane do zajęć i obowiązków.',
        icon: <FaClock />
    },
    {
        id: 2,
        title: 'Wymagania i oczekiwania',
        description: 'Nie wymagamy doświadczenia - wystarczy chęć nauki i zaangażowanie.',
        icon: <FaGraduationCap />
    },
    {
        id: 6,
        title: 'Dokumenty i formalności',
        description: '- wystawiamy zaświadczenia o odbyciu praktyk, \n- podpisujemy niezbędne dokumenty dla szkół i uczelni, \n- zapewniamy opiekuna praktyk na cały okres współpracy.',
        icon: <FaArrowUp />
    },
];

const sampleTasks = [
    "Prace ogrodnicze i pielęgnacyjne",
    "Prace w drzewostanie",
    "Pomoc przy organizacji wydarzeń i warsztatów",
    "Współtworzenie treści na stronę i media społecznościowe",
    "Wsparcie projektów edukacyjnych i kulturalnych",
    "Dokumentacja działań (zdjęcia, notatki, raporty)",
    "Prace administracyjne i organizacyjne"
];

export { positions, benefits, careerIntro, sampleTasks };
